import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
} from '@mui/material';

const AboutPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa', pt: 8 }}>
      <Container maxWidth="lg">
        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h3" gutterBottom color="primary">
            About Bloomaroot
          </Typography>
          <Typography variant="body1" paragraph>
            Bloomaroot is a platform dedicated to providing tools and resources for community builders who run clubs and teams. Our mission is to empower those who are committed to growing positive young adults through grace-root activities and meaningful engagement.
          </Typography>
          <Typography variant="body1" paragraph>
            We believe that community organizations play a vital role in shaping the next generation. Whether you're coaching a sports team, running a club, or organizing activities, our tools are designed to make your work more efficient and impactful.
          </Typography>
          <Typography variant="h5" gutterBottom color="secondary" sx={{ mt: 4 }}>
            Our Vision
          </Typography>
          <Typography variant="body1" paragraph>
            To create a world where community builders have access to the best tools and resources they need to focus on what matters most: mentoring and developing young people into positive, contributing members of society.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default AboutPage;
